var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-1 w-full"},[_c('div',{staticClass:"h-full min-h-[4px] w-full rounded bg-neutral-lighter"},[_c('div',{staticClass:"h-full rounded bg-primary",style:({ width: _vm.percentage + '%' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }